import { Box, Stack } from "@mui/material"
import { AuthoringAmendsAuditContent } from "authoring/routes/project/amends/components/authoring-amends-audit-content"
import { createSlot } from "lib/@components/slot/create-slot"
import { getAuthoringNoteLabel } from "./lib/authoring-author-notes-data"
import { hasAudienceAmendsContent } from "../amends/lib/audience-aware-amends.mjs"

export const AuthoringAuthorNoteBoxAction = createSlot("Authoring.AuthorNoteBoxAction")

export function AuthoringAuthorNoteBox({ item: amend }) {
    if (!amend?.payload) return null
    if (!hasAudienceAmendsContent(amend.payload)) return null

    const payload = {
        ...amend.payload,
        hideTaskTitle: true,
        label: getAuthoringNoteLabel(amend),
    }

    return (
        <Box
            sx={{
                bgcolor: "background.neutral",
                borderRadius: 2,
                p: 1.5,
            }}
        >
            <Stack direction="row" spacing={1} alignItems="flex-start">
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <AuthoringAmendsAuditContent payload={payload} />
                </Box>
                <AuthoringAuthorNoteBoxAction.Slot amend={amend} />
            </Stack>
        </Box>
    )
}
